import React, { useState, useEffect, useRef } from "react";
import { DataTable } from 'primereact/datatable';
import axios from 'axios';
import { Column } from 'primereact/column';
import { Toast } from 'primereact/toast';
import { Paginator } from 'primereact/paginator';
import LoadingSpinner from "../Spinner/LoadingSpinner";
import { InputText } from 'primereact/inputtext';
import exportData from "../../services/exportToExcelService";
import { Toolbar } from 'primereact/toolbar';
import { Button } from "primereact/button";
import AccessControl from "../AccessControl";
import NoAccess from "../NoAccess";
import { RowsPerPageDropdown } from "../../enums/RowsPerPageOptions";
import { Dropdown } from 'primereact/dropdown';
import { Dialog } from 'primereact/dialog';

const RolesList = () => {

    const [Roles, SetRoles] = useState([]);
    const [skip, setSkip] = useState(0)
    const [limit, setLimit] = useState(RowsPerPageDropdown[0])
    const [totalRecords, setTotalRecords] = useState(0)
    const [pageno, setpageno] = useState(1)
    const [isLoading, setIsLoading] = useState(false);
    const toast = useRef(null);
    const dt = useRef(null);
    const [RoleName, setRoleName] = useState(null);
    const [enableFilter, setEnableFilter] = useState(false);
    const [filterDialog, setFilterDialog] = useState(false);

    useEffect(() => {
        GetrolesList();
    }, [pageno, limit]);

    const GetrolesList = (isExportExcel = false) => {
        setIsLoading(true);
        if (!isExportExcel) SetRoles([])
        axios.post('/api/Roles/GetAll', {
            sortOrder: "-1",
            CurrentPageNumber: pageno,
            PageSize: limit,
            RoleName: RoleName ? RoleName : null
        }).then(Response => {
            if (isExportExcel) {
                exportData(Response.data.data, "Batch")
                setIsLoading(false);
                return false;
            }
            SetRoles(Response.data.data)
            setTotalRecords(Response.data.totalRecords)
            setIsLoading(false);
        })
            .catch((error) => {
                setIsLoading(false);
                toast.current.show({ severity: 'error', summary: 'Error', detail: 'Oops! Something Went Wrong!', life: 3000 });
            });
    };


    //pagination
    const onBasicPageChange = (event) => {
        setIsLoading(true);
        SetRoles([])
        setSkip(event.first)
        setLimit(event.rows)
        setpageno((event.first / event.rows) + 1)
        GetrolesList()
        setIsLoading(false);
    }
    //Template for pagination
    const template2 = {
        layout: 'CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown',
        'CurrentPageReport': (options) => {
            return (
                <span style={{ color: 'var(--text-color)', userSelect: 'none', width: '19%', textAlign: 'center' }}>
                    Showing {options.first} to {options.last} of {options.totalRecords} entries
                </span>
            )
        },
        RowsPerPageDropdown: (options) => {
            return <span>Items Per Page :<Dropdown value={options.value} options={RowsPerPageDropdown} onChange={options.onChange} /></span>;
        },
    };

    const RolesFilter = () => {
        return (
            <InputText name="RoleName" value={RoleName} placeholder="Enter Role Name" onChange={(e) => setRoleName(e.target.value)}
                onKeyDown={(e) => RolesFilteronEnter(e)} style={{ width: '300px' }}></InputText>
        )
    }

    const RolesFilteronEnter = (e) => {
        if (e.key == "Enter") {
            if (e.target.value.trim() != null && e.target.value.trim() != "") {
                setRoleName(e.target.value);
                setIsLoading(true);
                GetrolesList();
            } else {
                setRoleName(null);
                setIsLoading(true);
                GetrolesList();
            }
        }
    }

    const exportExcel = () => {
        GetrolesList(true);
    };

    const SearchFilter = () => {
        setSkip(0);
        setpageno(1);
        GetrolesList();
        setFilterDialog(false);
    };

    const filterDialogFooter = (
        <div className="filter-dialog-footer">
            <Button label="Clear Filter" icon="pi pi-filter-slash" className="p-button-outlined" onClick={() => { setRoleName(null); GetrolesList(); setFilterDialog(false); }} />
            <Button label="Apply Filter" icon="pi pi-check" className="p-button-primary" onClick={() => SearchFilter()} />
        </div>
    );

    // Left Side Toolbar
    const leftToolbarTemplate = () => {
        return (
            <div className="my-2 admin-toolbar-left">
                <h4 className="headerfont m-auto mr-2">Count : {totalRecords}</h4>
            </div>
        );
    };

    // Right Side Toolbar
    const rightToolbarTemplate = () => {
        return (
            <div className="my-2 admin-toolbar-right">
                <Button label="Filter" icon="pi pi-filter" className="p-button-outlined mr-2 mobile-only-btn" onClick={() => setFilterDialog(true)} />
                <Button type="button" disabled={RoleName == null} icon="pi pi-filter-slash" className="mr-2" onClick={(e) => { setRoleName(null); GetrolesList() }} tooltip="Reset Filter" tooltipOptions={{ position: "bottom", className: "showtooltip" }} outlined></Button>
                <Button disabled={!(Roles != null && Roles.length > 0)} tooltip="Export Excel" tooltipOptions={{ position: "bottom", className: "showtooltip" }} onClick={() => { exportExcel(); }} icon="pi pi-file-excel" className="mr-2" outlined />
            </div>
        );
    };

    return (
        <AccessControl
            allowedPermissions={["list:roles"]}
            renderNoAccess={() => <NoAccess />}
        >
            <div className="trico-Grid">
                {isLoading ? <LoadingSpinner /> :
                    (
                        <>
                            <div className="p-col">
                                <div className="card">
                                    <Toast ref={toast} />
                                    <h5 className="headerfont"><span><i className="fa fa-solid fa-cog mr-2"></i>Roles</span></h5>
                                    <Toolbar left={leftToolbarTemplate} right={rightToolbarTemplate} className="mb-3"></Toolbar>
                                    <div className="attendee-status-desktop-table">
                                        <DataTable ref={dt} value={Roles}
                                            dataKey="id" className="datatable-responsive"
                                            responsiveLayout="scroll" filterDisplay={"row"}>
                                            <Column field="name" header="Name" sortable filter filterElement={RolesFilter} showFilterMenu={false}></Column>
                                        </DataTable>
                                    </div>
                                    <div className="attendee-status-mobile-cards">
                                        {Roles && Roles.length > 0 ? (
                                            <div className="attendee-card-grid">
                                                {Roles.map((row, idx) => (
                                                    <div className="attendee-mobile-card" key={row.id || idx}>
                                                        <div className="attendee-card-top">
                                                            <span className="attendee-card-id">#{idx + 1 + skip}</span>
                                                        </div>
                                                        <div className="attendee-card-name">
                                                            {row.name}
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        ) : (
                                            <div className="p-text-center p-p-4" style={{ textAlign: 'center', padding: '2rem', color: '#888' }}>
                                                No Roles found.
                                            </div>
                                        )}
                                    </div>
                                    <Paginator className='justify-content-end admin-paginator' first={skip} rows={limit} totalRecords={totalRecords} template={template2} rowsPerPageOptions={RowsPerPageDropdown} onPageChange={onBasicPageChange} ></Paginator>
                                </div>
                            </div>
                            <Dialog visible={filterDialog} style={{ width: '90vw', maxWidth: '500px' }} header="Filter Roles" modal className="p-fluid admin-dialog attendee-filter-dialog" footer={filterDialogFooter} onHide={() => setFilterDialog(false)}>
                                <div className="filter-dialog-grid">
                                    <div className="filter-field-item">
                                        <label htmlFor="m_role_name">Role Name</label>
                                        <InputText id="m_role_name" value={RoleName || ''} placeholder="Enter Role Name" onChange={(e) => setRoleName(e.target.value)} />
                                    </div>
                                </div>
                            </Dialog>
                        </>
                    )
                }
            </div>
        </AccessControl>
    );
};

export default RolesList;